import type { AlertResponse } from '@/api/types/Alert'
import type { PaginationParamsType } from '@/api/request'

import Text from '@/elements/Text'
import Flex from '@/elements/Flex'
import Pagination from '@/components/Pagination'
import useBreakpoints from '@/hooks/useBreakpoints'

import WatchdogAlertCard from './WatchdogAlertCard'
import Button from '@/elements/Button'

interface WatchdogAlertListProps {
  alerts: AlertResponse[]
  pagination?: PaginationParamsType
  onPageChange: (page: number) => void
  showIndividual?: boolean
  clearFilters?: () => void
}

function WatchdogAlertList({
  alerts,
  pagination,
  onPageChange,
  showIndividual = false,
  clearFilters
}: WatchdogAlertListProps) {
  const { isMobile } = useBreakpoints()

  return (
    <Flex wfull hfull grow align='center'>
      <Flex wfull gap={2} pt={2} className='card'>
        {alerts.length === 0 ? (
          <Flex wfull hfull align='center' justify='center' py={8} px={4}>
            {!clearFilters ? (
              <Text color='black-light-60'>There are no alerts to display.</Text>
            ) : (
              <Flex gap={3} align='center' p={4}>
                <Text color='black-light-60'>There are no alerts matching the selected filters.</Text>
                <Button variant='primary' onClick={clearFilters}>Clear filters</Button>
              </Flex>
            )}
          </Flex>
        ) : (
          alerts.map(alert => (
            <WatchdogAlertCard
              key={alert.id}
              alert={alert}
              showIndividual={showIndividual}
            />
          ))
        )}
      </Flex>
      {pagination && (
        <Flex align='center' pt={4} mt='auto'>
          <Pagination
            variant={isMobile ? 'compact' : 'default'}
            onPageChange={onPageChange}
            {...pagination}
          />
        </Flex>
      )}
    </Flex>
  )
}

export default WatchdogAlertList
